export default{
    CREATE_Chapter(state, payload){
        state.chapter = payload;
    },
    GET_Chapter_DATA(state, payload){
        state.chapterlist = payload;
    },
    GET_SINGLE_COURSE(state, payload){
        state.courseDetails = payload;
    },
}